import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Center,
  Container,
  Grid,
  Heading,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { useMemo } from "react";
type Faq = {
  question: string;
  answer: string;
};

export const CoacheeFAQ = () => {
  const t = useTranslations("CoacheePage.faq");

  const faqs = useMemo(
    () =>
      Array.from({ length: 12 }, (_, index) => ({
        question: t.raw(`question${index + 1}`),
        answer: t.raw(`answer${index + 1}`),
      })),
    [t]
  );

  const [left, right] = useMemo(() => {
    return [
      faqs.filter((_, index) => index % 2 === 0),
      faqs.filter((_, index) => index % 2 === 1)
    ];
  }, [faqs]);

  return (
    <Container maxW="container.xl">
      <Stack
        gap={{ base: 8, md: 8 }}
        pt={{ base: 24, md: 24 }}
        px={{
          base: 8,
          md: 20,
        }}
        pb={{ base: 8, md: 12 }}
        position="relative"
        className="landing-page"
      >
        <Heading textAlign="center" mb={8}>
          FAQ
        </Heading>
        <Grid gridTemplateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={8}>
          <Accordion allowToggle>
            {left.map((faq, index) => (
              <AccordionItem
                key={faq.question}
                bgColor={"brand.100"}
                color="brand.1000"
                px={1}
                py={2}
                borderRadius="12px"
                mb={4}
                border="2px solid"
                borderColor="brand.1000"
                _last={{
                  borderBottomWidth: "none",
                }}
              >
                <h2>
                  <AccordionButton>
                    <Box
                      as="span"
                      flex="1"
                      fontSize="18px"
                      textAlign="left"
                      fontWeight={600}
                      dangerouslySetInnerHTML={{ __html: faq.question }}
                    />
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4} color="brand.1000">
                  <Text dangerouslySetInnerHTML={{ __html: faq.answer }} />
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
          <Accordion allowToggle>
            {right.map((faq, index) => (
              <AccordionItem
                key={faq.question}
                bgColor={"brand.100"}
                color="brand.1000"
                px={1}
                py={2}
                borderRadius="12px"
                mb={4}
                border="2px solid"
                borderColor="brand.1000"
                _last={{
                  borderBottomWidth: "none",
                }}
              >
                <h2>
                  <AccordionButton>
                    <Box
                      as="span"
                      flex="1"
                      fontSize="18px"
                      textAlign="left"
                      fontWeight={600}
                      dangerouslySetInnerHTML={{ __html: faq.question }}
                    />
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4} color="brand.1000">
                  <Text dangerouslySetInnerHTML={{ __html: faq.answer }} />
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </Grid>
        <Text
          dangerouslySetInnerHTML={{ __html: t.raw("callToAction") }}
          textAlign="center"
          fontSize="1.2rem"
          mt={8}
        />
        <Center>
          <Link href="#schedule">
            <Button
              size="lg"
              fontSize="2xl"
              w={{ base: "full", md: "auto" }}
              variant={"primary"}
            >
              <Text
                dangerouslySetInnerHTML={{ __html: t.raw("scheduleButton") }}
              />
            </Button>
          </Link>
        </Center>
      </Stack>
    </Container>
  );
};
